import { render } from "./tabelaPrecoView.vue?vue&type=template&id=2cda297a"
import script from "./tabelaPrecoView.vue?vue&type=script&lang=js"
export * from "./tabelaPrecoView.vue?vue&type=script&lang=js"

import "./tabelaPrecoView.vue?vue&type=style&index=0&id=2cda297a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__